import React, { useState, useEffect } from "react";
import Category from "./shopBy/Category";
import { useSearchParams } from "react-router-dom";

const ShopSideNav = ({ closeSidebar }) => {
  const [searchParams] = useSearchParams();
  const genderFromURL = searchParams.get("gender");

  // Open the category panel that matches the URL if any
  const [openCategory, setOpenCategory] = useState(genderFromURL || null);

  useEffect(() => {
    if (genderFromURL) {
      setOpenCategory(genderFromURL);
    }
  }, [genderFromURL]);

  const toggleCategory = (category) => {
    setOpenCategory(openCategory === category ? null : category);
  };

  return (
    <div className="mt-8 w-full flex flex-col gap-6">
      <Category
        gender="Men"
        closeSidebar={closeSidebar}
        isOpen={openCategory === "Men"}
        toggleCategory={() => toggleCategory("Men")}
      />
      <Category
        gender="Women"
        closeSidebar={closeSidebar}
        isOpen={openCategory === "Women"}
        toggleCategory={() => toggleCategory("Women")}
      />
      <Category
        gender="Accessoire"
        closeSidebar={closeSidebar}
        isOpen={openCategory === "Accessoire"}
        toggleCategory={() => toggleCategory("Accessoire")}
      />
    </div>
  );
};

export default ShopSideNav;
